import { render, staticRenderFns } from "./EmptyMessage.vue?vue&type=template&id=00abaf9a&"
import script from "./EmptyMessage.vue?vue&type=script&lang=js&"
export * from "./EmptyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports